export default __webpack_public_path__ + "static/media/logo-text.2e2f7980.png";